import type { ButtonHTMLAttributes, JSX, ReactNode } from 'react';
import { classNames } from '../utils/class-names.ts';

export const ButtonVariant = ['primary', 'secondary', 'ghost', 'danger'] as const;
export type ButtonVariant = (typeof ButtonVariant)[number];

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: ButtonVariant;
}

export function Button({
  children,
  className,
  type = 'button',
  variant = 'secondary',
  ...props
}: ButtonProps): JSX.Element {
  return (
    <button
      className={classNames('fui-button', `fui-button-${variant}`, className ?? false)}
      type={type}
      {...props}
    >
      {children}
    </button>
  );
}
